export enum CardDocumentAction {
	ARCHIVE = 'ARCHIVE',
	UNARCHIVE = 'UNARCHIVE',
	DELETE = 'DELETE',
	DOWNLOAD = 'DOWNLOAD',
	MOVE = 'MOVE',
	CHANGE = 'CHANGE'
}
